import * as yup from 'yup';
import {SurveyComponentTypes} from '../../types';
import {validationErrors} from '../../../../constants/constants';
import {EDITABLE_COMPONENTS} from '../../../../constants/surveys';

const getTextValidationSchema = (isRequired, details, email = false) => {
  const {maxlength} = JSON.parse(details) || {};

  let schema = email? yup.string().email(validationErrors.email) : yup.string();

  if (maxlength) {
    schema = schema.max(maxlength, validationErrors.maxLength(maxlength));
  }

  if (isRequired) {
    schema = schema.required(validationErrors.required);
  }

  return schema.nullable();
};

const getValidationSchemaByType = (type, isRequired, details) => {
  switch (type) {
    case SurveyComponentTypes.TEXT:
      return getTextValidationSchema(isRequired, details, true);
    case SurveyComponentTypes.RADIO:
      return yup.string().required(validationErrors.required);
    case SurveyComponentTypes.RATING:
      return yup.string().required(validationErrors.required);
    case SurveyComponentTypes.TEXTAREA:
      return getTextValidationSchema(isRequired, details);
    default:
      return yup.object().nullable();
  }
};

export const generateValidationSchema = (
    components
) => yup.lazy(() => {
  return yup.object().shape(
      components
          .filter((item) => item.type === EDITABLE_COMPONENTS[item.type])
          .reduce((acc, {id, type, required, details}) => {
            acc[id] = getValidationSchemaByType(type, required, details);

            return acc;
          }, {})
  );
});
